function getBase(state) {
  return state.contentControls.enhanced;
}

export function isEnhancedFormattingEnabled(state) {
  return getBase(state).enabled;
}

export function getReaderView(state) {
  return getBase(state).readerView;
}

export function getFontFamily(state) {
  return getBase(state).fontFamily;
}

export function getFontSize(state) {
  return getBase(state).fontSize;
}

export function getPageMargin(state) {
  return getBase(state).pageMargin;
}

export function getDisplayMode(state) {
  return getBase(state).displayMode;
}

export function getLineHeight(state) {
  return getBase(state).lineHeight;
}
